module.exports = __webpack_public_path__ + "img/Cookie_1_resize_14.24495cc3.png";